import { render, staticRenderFns } from "./PageSpeciaux.vue?vue&type=template&id=77c32869&"
import script from "./PageSpeciaux.vue?vue&type=script&lang=js&"
export * from "./PageSpeciaux.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports